import Vue from 'vue'
import pinia from '@/store'
import { defineStore } from 'pinia'
import { useUserStore } from '@/store/user'
import { useMenuStore } from '@/store/menu'
import { ls } from '@/store/token'
import { GlobalActions } from '../../../../enums/globa'

export enum ClientType {
  Web = 1, // Web
  App = 2, // App
  ElectricVehicleInspection = 3, // 电动自行车安全隐患全链条整治平台
}

export interface ClientState {
  currentClient: ClientType
  clients: ClientType[]
}

export const useClientStore = defineStore('useClientStore', {
  state: (): ClientState => {
    return {
      currentClient: ls.get('client') || ClientType.Web,
      clients: [],
    }
  },
  actions: {
    setClientInfo(params: { clients: ClientType[]; currentClient: ClientType }) {
      const hasClient = params.clients.some((itemClient) => itemClient === params.currentClient)
      if (!hasClient) return
      this.clients = params.clients
      this.currentClient = params.currentClient
    },

    changeToClient(value: ClientType) {
      return new Promise<boolean>(async (resolve, reject) => {
        const hasClient = this.clients.some((itemClient) => itemClient === value)
        if (!hasClient) return console.error(`当前角色没有 ${value} Client！`)

        this.currentClient = value
        ls.set('client', this.currentClient)
        const userStore = useUserStore(pinia)
        const menuStore = useMenuStore(pinia)

        try {
          const res = await userStore.init()
          menuStore.init({
            menus: res.data.menus || [],
            originalMenus: res.data.menus || [],
            buttons: res.data.buttons || [],
          })

          Vue.prototype.$setGlobalState({
            action: GlobalActions.SetClient,
            clients: this.clients,
            currentClient: this.currentClient,
            originalMenus: res.data.menus,
            menus: res.data.menus,
            buttons: res.data.buttons,
          })
          resolve(true)
        } catch (e) {
          console.error(e)
          reject()
        }
      })
    },

    reset() {
      this.currentClient = ls.get('client') || ClientType.Web
      this.clients = []
    },
  },
})
